import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { DbShareTenderFolder } from '~src/types/db';
import { loadPublicTenderCoreFolders } from '~src/services/api/shares';

export const usePublicTenderCoreFolders = (
  tenderShareId?: string,
  queryConfig: QueryConfig<DbShareTenderFolder[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const { enabled, ...options } = queryConfig;
  const enabledOverwrite =
    Boolean(tenderShareId) && (enabled || enabled === undefined);

  const publicTenderFoldersQuery = useQuery<DbShareTenderFolder[], AxiosError>(
    ['publicTenderCoreFolders', tenderShareId],
    () =>
      loadPublicTenderCoreFolders({
        tenderShareId: tenderShareId as string,
      }),
    {
      // refetch every 5 min, same as shared folders
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite,
      ...options,
    }
  );

  return publicTenderFoldersQuery;
};
